import React from 'react';
import { SlideProps } from '../SlideHandler';
import parse from 'html-react-parser';
import { checkString } from '../../../componentUtils';
import {
	TourLine,
	VTDescription,
	VTDescriptionContainer,
	VTSlideInner,
	VTSlideTitle,
	VTTrailTitle,
} from '../virtualTourStyles';
import { BGTest } from '../../../Global/styles';
import { BackgroundTest } from '../../../Global/Icons/Icons';

const TextSlide: React.FC<SlideProps> = ({ point, title }) => {
	return (
		<>
			<VTSlideInner>
				<BGTest>
					<BackgroundTest />
				</BGTest>
				{title && <VTTrailTitle>{title}</VTTrailTitle>}
				<VTSlideTitle>{point.title}</VTSlideTitle>
				<VTDescriptionContainer>
					{/* <VTGradient /> */}
					<VTDescription>
						{parse(checkString(point.short_description))}
						{parse(checkString(point.description))}
					</VTDescription>
				</VTDescriptionContainer>
			</VTSlideInner>
			<TourLine />
			{/* <ForwardArrow /> */}
		</>
	);
};

export default TextSlide;
